import React from 'react';
import { Link } from 'react-router-dom';
import styles from './CtaBlock.module.scss';

export interface CtaBlockProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  buttonPath?: string;
  secondaryButtonText?: string;
  secondaryButtonPath?: string;
}

export const CtaBlock: React.FC<CtaBlockProps> = ({
  title = "Ready for a professional website without the hassle?",
  subtitle = "Tell us what you need, and we'll take care of the rest.",
  buttonText = "Get in Touch",
  buttonPath = "/contact",
  secondaryButtonText,
  secondaryButtonPath,
}) => {
  return (
    <div className={styles.ctaBlock}>
      <h2 className={styles.title}>{title}</h2>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      <div className={styles.actions}>
        <Link to={buttonPath} className={styles.primaryButton}>
          {buttonText}
        </Link>
        {secondaryButtonText && secondaryButtonPath && (
          <Link to={secondaryButtonPath} className={styles.secondaryButton}>
            {secondaryButtonText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default CtaBlock;
